import listTicketFilterStatus from 'app/_shared/events/collection/listTicketFilterStatus'
import { get } from 'lib/sequence/component/state/value'

/**
 * Sets the status filter according to the selected value.
 *
 * @param {Gaia.AppModule.Spec} module the ticket module composition object
 * @returns {function(*, {filter?: {}}=, ...[*]): Promise<[undefined,{filter: {}},...*[]]>}
 */
export default module => component => async (children, { filter = {} } = {}, ...args) => {
  const { status } = children

  const accumulatedFilter = filter
  const selectedStatus = parseInt(get(status), 10)
  const statusSelection = listTicketFilterStatus(module, component, null)
  const statusOption = statusSelection.find(option => option.key === selectedStatus)
  statusOption?.key && (accumulatedFilter.workState = statusOption.key)

  return [children, { filter: accumulatedFilter }, ...args]
}
